/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/apps/common/js/jquery/aacom/plugins/aaSessionTimeout.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/legacy/utilities/aa-session-timeout.js
**/

/* global VirtualPnrTimeoutAjaxAction:true */

var sessionTimeOutDialog = function() {
    var self = {},
        renewTimer,
        aaUtilities,
        $sessionTimeoutDialog,
        $title,
        $body,
        $continueButton,
        $homeButton,
        $isDisplayVirtualPNRModal,
        $isFinalDisplayModal,
        $bookingPathStateId,
        $searchFeature,
        $closeButton,
        _dialogName='sessionTimeOut',
        _dialogID='#sessionTimeOutDialog',
        sessionTimer;
    self.properties = {};
    self.init = function() {
        if(jQuery(_dialogID).length > 0) {
            jQuery(document).ready(function() {
                aaUtilities = new aa_Utilities();
                var buttons = [{
                                name: self.properties['session.warning.button'],
                                cssClass: "btn aa-btn aa-btn-primary no-margin",
                                callback: self.continueSession,
                                closeDialog: false
                            },
                            {
                                name: self.properties['session.expired.button'],
                                cssClass: "btn aa-btn aa-btn-primary no-margin is-hidden",
                                callback: self.home,
                                closeDialog: false
                            },
                            {
                                name: self.properties['sessionCloseButton'],
                                cssClass: "btn aa-btn aa-btn-primary no-margin is-hidden",
                                callback: function(){
                                            if(typeof $device !=="undefined" && $device.mobileApp !=="undefined" && $device.mobileApp){
                                                self.appStartOver();
                                            }else{
                                                self.home();
                                            }
                                         },
                                closeDialog: false
                            }
                            ];
                aaUtilities.aaDialog(_dialogName, {
                    width:"small",
                    buttons: buttons,
                    toggleScroll: true,
                    showClose: false,
                    showFullScreen:true,
                    hideCloseInApp : true,
                    closeOnEscape: false,
                    zIndex: 99999
                });
                self.sessionDialogElements();
                self.startSessionTimer();
            });
        }
    };
    self.sessionDialogElements = function() {
        $sessionTimeoutDialog = jQuery(_dialogID).parents(".ui-dialog:first");
        $title = $sessionTimeoutDialog.find(".ui-dialog-title");
        $body = $sessionTimeoutDialog.find(".js-dialogBody");
        $continueButton = $sessionTimeoutDialog.find(_dialogID+'Button0');
        $homeButton = $sessionTimeoutDialog.find(_dialogID+'Button1');
        $closeButton = $sessionTimeoutDialog.find(_dialogID+'Button2');
        $isDisplayVirtualPNRModal = self.properties['isDisplayVirtualPNRModal'];
        $isFinalDisplayModal = self.properties['isFinalDisplay'];
        $searchFeature = self.properties['searchFeature'];
        $bookingPathStateId = self.properties['bookingPathStateId'];
    };
    self.open = function() {
        aaUtilities.aaDialog(_dialogName).openDialog();
        self.startSessionRenewTimer();
    };
    self.startSessionTimer = function() {
        var sessionTimeoutBuffer = 5000;
        var sessionExpiresWarningInterval  = self.properties['sessionExpiresWarningInterval'];
        var sessionMaxInactiveTime = self.properties['sessionTimeOut'] * 1000;
        var sessionWarningCountDown = 0;
        if(self.finalDisplay()){
            renewTimer = setTimeout(function(){ self.sessionExpiredDialog();}, sessionMaxInactiveTime - sessionTimeoutBuffer );
        }else{
         sessionWarningCountDown = sessionMaxInactiveTime - sessionExpiresWarningInterval  - sessionTimeoutBuffer;
         sessionTimer = setTimeout(function(){ self.open();}, sessionWarningCountDown);
        }
    };
    self.startSessionRenewTimer = function() {
        var sessionExpiresWarningInterval  = self.properties['sessionExpiresWarningInterval'];
        renewTimer = setTimeout(function(){ self.sessionExpiredDialog();}, sessionExpiresWarningInterval );
    };
    self.sessionExpiredDialog = function() {
        $title.html(self.properties['session.expired.title']);
        $body.html(self.properties['session.expired.message']);
        $continueButton.addClass("is-hidden");
        $homeButton.removeClass("is-hidden");
        // Close and reopen dialog so that screen readers will read it
        aaUtilities.aaDialog(_dialogName).closeDialog();
        aaUtilities.aaDialog(_dialogName).openDialog();
        if(self.virtualPNRExists()){
            deleteVirtualPNR();
        }

        // needed only if change the button name for award
        if(self.awardReservation() || (typeof $device !=="undefined" && $device.mobileApp)){
        	$homeButton.addClass("is-hidden");
            $closeButton.removeClass("is-hidden");
        }
    };
    self.continueSession = function() {
        self.stopTimers();

        jQuery.ajax({
            url: "/shared/session/renew/",
            type: 'POST',
            timeout: 50000,
            success: function() {
                if(self.virtualPNRExists()){
                     self.updateVirtualPNRHoldTime();
                }else{
                     self.resetTimersToContinue();
                }

            },
           error: function() {
                self.stopTimers();
                self.open();
                self.sessionExpiredDialog();
            }
        });

        aaUtilities.aaDialog(_dialogName).closeDialog();
        return false;
    };

    self.stopTimers = function() {
        clearTimeout(renewTimer);
        renewTimer = null;
        clearTimeout(sessionTimer);
        sessionTimer = null;
    };

    self.resetTimersToContinue = function() {
        self.stopTimers();
        self.startSessionTimer();
    };

    self.virtualPNRExists = function () {
        var returnValue = false;
        if ($isDisplayVirtualPNRModal == "true" || $isDisplayVirtualPNRModal == true) {
            returnValue = true;
        }
        return returnValue;
    };
    self.finalDisplay = function () {
        var returnValue = false;
        if ($isFinalDisplayModal == "true" || $isFinalDisplayModal == true) {
            returnValue = true;
        }
        return returnValue;
    };

    self.awardReservation = function () {
        if ($searchFeature == "award") {
            return true;
        }
        return false;
    };

    self.updateVirtualPNRHoldTime = function () {
        VirtualPnrTimeoutAjaxAction.updateVirtualPNRHoldTime($bookingPathStateId, {
            timeout: 30000,
            errorHandler: self.handleAjaxTimeout,
            callback: self.handleUpdateCallBack
        });
    };
    self.handleUpdateCallBack = function (callback) {
        self.initializeStateAttributesViaAjax(callback);
        self.resetTimersToContinue();
    };

    self.handleAjaxTimeout = function (message) {
        self.stopTimers();
        self.open();
        self.sessionExpiredDialog();
    };

    self.initializeStateAttributesViaAjax = function (callback) {
        $isFinalDisplayModal = callback.finalVirtualPNRModal;
    };

    self.redirectToStartOverPage = function () {
       return "/reservation/awardFlightSearchAccess.do";
    };

    self.home = function() {
        jQuery.ajax({
            url: "/shared/session/expired/",
            type: 'POST',
            dataType: 'text',
            data: { 'bookingPathStateId': $bookingPathStateId},
            timeout: 50000,
            success: function(jsonResponse) {
                window.location.href = (self.awardReservation()?self.redirectToStartOverPage():"/homePage.do");
            },
            error: function() {
                window.location.href = '/homePage.do';
            }
        });
    };
    self.appStartOver = function(){
        //Send message to the app for session expiration.
       $j(document).trigger("bridge.aacomToNativeApp",{
           name: "sessionExpired"
       });
    }
    return self;
}();

